class BeraraWpcBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('.berara-wpc-compare__range');
    if (!this.range) return;
    this.update = () => this.style.setProperty('--split', `${this.range.value}%`);
    this.range.addEventListener('input', this.update);
    this.update();
  }

  disconnectedCallback() {
    if (this.range && this.update) this.range.removeEventListener('input', this.update);
  }
}

if (!customElements.get('berara-wpc-before-after')) {
  customElements.define('berara-wpc-before-after', BeraraWpcBeforeAfter);
}
